const QUOTES = [
  {
    text: "Steve Lamphear's dual PE and PS licensure saved us weeks on stormwater approval. Having the surveyor and design engineer as the exact same person eliminated miscommunication entirely.",
    attribution: "Commercial Project Developer · Central Ohio"
  },
  {
    text: "Accurate 3D machine control models and prompt construction staking kept our earthwork crew running without downtime. Unmatched field experience.",
    attribution: "Site Civil Contractor · Dublin, OH"
  }
];

export const Testimonials = () => (
  <section id="reviews" className="py-24 bg-stone-50 border-b border-stone-200" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-12">
        <h2 className="text-xs font-bold uppercase tracking-widest text-amber-800 mb-2">Client Testimonials</h2>
        <p className="font-display text-3xl font-bold text-stone-950">Trusted by Ohio Builders &amp; Developers</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {QUOTES.map((q, i) => (
          <div key={q.attribution} className="p-8 rounded-xl bg-white border border-stone-200 shadow-sm flex flex-col justify-between" data-testid={`testimonial-card-${i + 1}`}>
            <p className="text-sm text-stone-700 italic leading-relaxed">"{q.text}"</p>
            <div className="mt-6 pt-4 border-t border-stone-100 text-xs font-bold text-stone-900">
              {q.attribution}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
